export type CurrencySymbol = keyof typeof currencySymbols;

// Adding a currency? See fbot/src/currency.ts for all 9 places it must be added.
export const currencySymbols = {
  percent: "%",
  AED: String.fromCharCode(0x62f, 0x2e, 0x625),
  AUD: "A$",
  BRL: "R$",
  GBP: "£",
  CAD: "C$",
  CHF: String.fromCharCode(8355),
  CLP: "CLP$",
  CZK: "Kč",
  DKK: "kr.",
  EUR: "€",
  HKD: "HK$",
  HUF: "Ft",
  INR: "₹",
  JPY: "¥",
  MXN: "₱",
  NZD: "NZ$",
  SEK: "kr",
  SGD: "S$",
  SKW: "₩",
  USD: "$",
  ZAR: "R",
};
